import NextImage from 'next/image'
import React from 'react'

import type { ImageProps, StaticImageData } from 'next/image'

export interface CustomImageProps extends ImageProps {
  fallback?: StaticImageData | string
}
const getImageSrc = (src: string) => {
  if (src?.[0] === '/') {
    return `${process.env.NEXT_PUBLIC_PATH_PREFIX}${src}`
  }
  return src
}

const Image = ({ src, fallback, ...props }: CustomImageProps) => {
  const parsedFallback =
    typeof fallback === 'string' ? getImageSrc(fallback) : fallback
  const [imgSrc, setImgSrc] = React.useState(
    typeof src === 'string' ? getImageSrc(src) : src
  )
  return (
    <NextImage
      key={imgSrc?.toString()}
      src={imgSrc ?? parsedFallback}
      onError={() => {
        setImgSrc(parsedFallback)
      }}
      {...props}
    />
  )
}

export default Image
